import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app, 'supernews'); // Use the named database 'supernews'
export const functions = getFunctions(app);

// Connect to emulators if explicitly enabled
// Create .env.local with REACT_APP_USE_EMULATOR=true to enable
// Use REACT_APP_USE_PROD_DB=true to use production Firestore with local functions
// Note: Auth emulator is skipped because Google OAuth Sign-In requires production Auth
const useEmulator = process.env.REACT_APP_USE_EMULATOR === "true";
const useProdDb = process.env.REACT_APP_USE_PROD_DB === "true";

if (useEmulator) {
  // Skip Auth emulator - Google OAuth Sign-In doesn't work with Auth emulator
  // Use production Firebase Auth for authentication
  // This allows Google Sign-In to work properly in local development
  console.log("Using production Firebase Auth (required for Google Sign-In)");
  
  // Only connect to Firestore emulator if not using production DB
  if (!useProdDb) {
    try {
      connectFirestoreEmulator(db, "localhost", 8080);
      console.log("Using local Firestore emulator with 'supernews' database");
    } catch (error) {
      // Already connected or connection failed, ignore
      console.log("Firestore emulator already connected or connection failed");
    }
  } else {
    console.log("Using production Firestore database: 'supernews'");
  }
  
  try {
    connectFunctionsEmulator(functions, "localhost", 5001);
    console.log("Using local Functions emulator");
  } catch (error) {
    // Already connected or connection failed, ignore
    console.log("Functions emulator already connected or connection failed");
  }
}

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

